<div class="col-start-1 col-end-2 row-start-1 row-end-[-1] grid justify-end gap-y-px pr-0.5"
  [style.gridTemplateRows]="calendarGridTemplateRows">
  @for (hour of hours; track hour) {
  @for (minute of minutesInTimeline; track minute) {
  <div class="row-span-1 text-right text-h8 text-text-extra-light">
    @if ($first) {
    {{ hour | hourToDayPartHour }} {{ hour | hourToDayPart }}
    } @else {
    {{ minute }}
    }
  </div>
  }
  }
</div>
